<template>
    <!-- 应用 -->
    <div>
        <page-content :pageType = pageType></page-content>
    </div>
</template>

<script>

import pageContent from '../../../components/thingjs-x/page-content.vue'
export default {

    data() {
        return {
            pageType:{
                name: 'application',
                pageType: 9999
            }
        }
    },
    components: {
      pageContent
    },
    methods: {

    }
}
</script>

<style lang = "less" scoped>

</style>



// WEBPACK FOOTER //
// src/views/thingjsX/category/application.vue